import { motion } from "framer-motion";
import { FadeUp, SectionLabel } from "./Reveal";
import { SERVICES, TOOLS, CLIENTS, QUOTES } from "../data/content";
import { useLang } from "../lib/lang";

const Card = ({ s, i }) => {
  const { tr } = useLang();
  return (
    <motion.div
      data-testid={`service-card-${i}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: i * 0.07 }}
      whileHover={{ y: -6 }}
      className={`group relative flex min-h-[240px] flex-col justify-between overflow-hidden rounded-3xl border border-white/10 bg-[var(--surface)] p-7 sm:p-9 ${s.wide ? "md:col-span-2" : ""}`}
    >
      <div className="absolute inset-0 origin-bottom scale-y-0 bg-[var(--acid)] transition-transform duration-500 ease-out group-hover:scale-y-100" />
      <span className="relative font-mono text-xs text-[var(--acid)] transition-colors group-hover:text-[var(--ink)]">{s.n}</span>
      <div className="relative">
        <h3 className="font-display text-3xl font-extrabold tracking-tight transition-colors group-hover:text-[var(--ink)] sm:text-4xl">{tr(s.title)}</h3>
        <p className="mt-3 max-w-md text-zinc-400 transition-colors group-hover:text-[var(--ink)]">{tr(s.text)}</p>
      </div>
    </motion.div>
  );
};

export const Services = () => {
  const { tr } = useLang();
  return (
    <section id="services" data-testid="services-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-36">
      <SectionLabel index="07">{tr({ es: "Servicios", en: "Services" })}</SectionLabel>
      <FadeUp as="h2" className="mt-6 max-w-4xl font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-7xl">
        {tr({ es: "Estrategia,", en: "Strategy," })} <span className="font-serif-i normal-case text-[var(--acid)]">{tr({ es: "belleza", en: "beauty" })}</span> {tr({ es: "y resultados.", en: "& results." })}
      </FadeUp>
      <div data-testid="skills-matrix" className="mt-14 grid gap-4 md:grid-cols-3">
        {SERVICES.map((s, i) => <Card key={s.n} s={s} i={i} />)}
      </div>
      <FadeUp className="mt-6 flex flex-wrap gap-2">
        {TOOLS.map((t) => <span key={t} className="rounded-full border border-white/15 px-4 py-2 font-mono text-xs text-zinc-300">{t}</span>)}
      </FadeUp>

      <div className="mt-28">
        <SectionLabel index="08">{tr({ es: "Marcas con las que he trabajado", en: "Brands I've worked with" })}</SectionLabel>
        <div data-testid="client-grid" className="mt-10 grid grid-cols-2 border-l border-t border-white/10 sm:grid-cols-3 lg:grid-cols-4">
          {CLIENTS.map((c) => (
            <div key={c} className="group flex h-24 items-center justify-center border-b border-r border-white/10 px-3 text-center transition-colors hover:bg-white sm:h-32">
              <span className="font-display text-base font-bold text-zinc-300 transition-colors group-hover:text-[var(--ink)] sm:text-xl">{c}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-28 grid gap-10 md:grid-cols-2">
        {QUOTES.map((q, i) => (
          <FadeUp key={q.who} delay={i * 0.1} className="border-l-2 border-[var(--acid)] pl-6">
            <p className="font-serif-i text-2xl leading-snug text-zinc-100 sm:text-3xl">“{tr(q.q)}”</p>
            <p className="mt-5 font-display font-bold">{q.who}</p>
            <p className="text-sm text-zinc-400">{tr(q.role)}</p>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};
